import React from 'react';
import { Advertorial } from './components/Advertorial';
export function App() {
  return <Advertorial data-id="element-0" />;
}